var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back px-0 pb-0 pt-lg-5 pt-md-0"},[_c('SitecoreLink',{staticClass:"icon ma-0 pa-0",attrs:{"iconField":this.fields.LinkIcon,"linkField":this.fields.Link}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }